import { importTypes } from '../../config/import';

export const urlKeys = {
  address: 'HousingStock/address/types',
  personalAccount: 'HousingStock/account_types',
  meter: 'Meter/individual_meter_types',
  meterStatus: 'Meter/individual_meter_statuses',
  meterLocation: 'Meter/individual_meter_locations',
};

export const urlList = Object.values(urlKeys);

export const returnTypesValueKeys = {
  loadingWithErrors: 'loadingWithErrors',
  data: 'data',
};

export const returnValueSet = new Set(Object.values(returnTypesValueKeys));

export const urlToTypeIdsKey = {
  [urlKeys.address]: 'addressTypeIds',
  [urlKeys.personalAccount]: 'accountTypeIds',
  [urlKeys.meter]: 'meterTypeIds',
  [urlKeys.meterStatus]: 'meterStatusTypeIds',
  [urlKeys.meterLocation]: 'meterLocationTypeIds',
};

const addressTypesTriggers = new Set([
  importTypes.owners,
  importTypes.personalAccounts,
  importTypes.individualMeters,
]);

export const isQueryEnabled = {
  [urlKeys.address]: (type) => addressTypesTriggers.has(type),
  [urlKeys.personalAccount]: (type) => type === importTypes.personalAccounts,
  [urlKeys.meter]: (type) => type === importTypes.individualMeters,
  [urlKeys.meterStatus]: (type) => type === importTypes.individualMeters,
  [urlKeys.meterLocation]: (type) => type === importTypes.individualMeters,
};

export const baseErrMsg =
  'Не удалось получить данные от сервера, необходимые для проверки файла.';
